import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'shabic-icon-arrow',
  templateUrl: './icon-arrow.component.html',
  styleUrls: ['./icon-arrow.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconArrowComponent {}
